import React from 'react'

import { Text } from '../presentation/Text'
import Checkbox from '../shapes/Checkbox'
import FlexGrid, { FlexColumn } from '../structure/FlexGrid'
import Link from '../actions/Link'
import ListItemWrapper from './ListItemWrapper'
import Plain from '../helpers/Plain'

const CheckboxListItem = ({ selected, invert, onSelect, label, cleanLabel, noWrapper, ...props }) => {
  const Wrapper = noWrapper ? Plain : ListItemWrapper
  return (
    <Link block onClick={() => onSelect(!selected)}>
      <Wrapper {...props}>
        <FlexGrid justify="flex-start" gutter={0.3}>
          {!invert && <Checkbox active={selected} />}
          <FlexColumn flex={1}>{cleanLabel ? label : <Text>{label}</Text>}</FlexColumn>
          {!!invert && <Checkbox active={selected} />}
        </FlexGrid>
      </Wrapper>
    </Link>
  )
}

export default CheckboxListItem
